import "./Services.module.css";
import Header from "@/reusable_sections/Header";
import Gebäudeautomation from "./sections/Gebäudeautomation";
import Energieoptimierung from "./sections/Energieoptimierung";
import SteuerungstechnikSps from "./sections/SteuerungstechnikSps";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Header />
      <Gebäudeautomation />
      <Energieoptimierung />
      <SteuerungstechnikSps />
      <Footer />
    </div>;
}